import styled from 'styled-components'
import { IconPin as Icon } from '@edulastic/icons'

export const IconPin = styled(Icon)`
  width: 20px;
  height: 20px;
`
